import { ApiClient, ApiError } from '@algo/api-client';

const baseUrl = import.meta.env.VITE_API_URL ?? 'http://localhost:4000';

/**
 * The token is empty until you sign in — `lib/session` swaps it in once the
 * backend hands one over, so it is never baked into the bundle.
 */
export const api = new ApiClient({ baseUrl, token: '', timeoutMs: 20_000 });

export { ApiError };

/** Centralised query keys so invalidation stays honest. */
export const qk = {
  profile: ['profile'] as const,
  dashboard: ['dashboard'] as const,
  topics: ['topics'] as const,
  topic: (id: string) => ['topics', id] as const,
  problems: (filters: unknown) => ['problems', filters] as const,
  problem: (id: string) => ['problems', id] as const,
  daily: (date?: string) => ['daily', date ?? 'today'] as const,
  sessions: (filters: unknown) => ['sessions', filters] as const,
  notes: (filters: unknown) => ['notes', filters] as const,
  tags: ['tags'] as const,
  achievements: ['achievements'] as const,
  weekly: (period?: string) => ['stats', 'weekly', period ?? 'current'] as const,
  monthly: (period?: string) => ['stats', 'monthly', period ?? 'current'] as const,
  ratingHistory: ['stats', 'rating-history'] as const,
  heatmap: (days: number) => ['stats', 'heatmap', days] as const,
  aiStatus: ['ai', 'status'] as const,
};

/**
 * Anything that changes source rows moves the rating, the streak and the
 * reports, so mutations invalidate broadly rather than surgically.
 */
export const INVALIDATE_ON_WRITE = [
  qk.dashboard,
  qk.topics,
  qk.achievements,
  qk.ratingHistory,
  ['stats'],
  ['problems'],
  ['daily'],
  ['sessions'],
];
